import { Button, Card, Col, Row, Stack } from "react-bootstrap";
import EstadoModulo from "./EstadoModulo.jsx";

function ModuloSeleccionado({ modulo, onClose }) {
  return (
    <Card className="p-4 h-100 shadow-sm border">
      <Row className="g-3 align-items-start">
        {/* IZQUIERDA (ocupa full en móviles, auto en grandes) */}
        <Col xs={12} md>
          <Stack gap={1}>
            <p className="h3 mb-0">{modulo.nombre}</p>
            <small className="text-muted">Mesón {modulo.numero}</small>

            {/* Badge controlado: no crece a lo ancho */}
            <div className="d-inline-block">
              <EstadoModulo estado={modulo.estado} />
            </div>
          </Stack>
        </Col>

        {/* DERECHA (auto, baja en móviles) */}
        <Col xs={12} md="auto" className="text-end ms-auto">
          <Button
            onClick={onClose}
            className="btn btn-danger px-4 py-2 w-100 w-auto ms-auto"
          >
            <i className="bi bi-x me-1"></i>
            Cerrar Módulo
          </Button>
        </Col>
      </Row>
    </Card>
  );
}

export default ModuloSeleccionado;
